import React from 'react'
import { APPROVAL_STATUS_OPTIONS, IXmlTariffModel } from './XmlTariffModel'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'
import { getSelectLabel } from '../../../../shared/models/SharedConstantLookups'
import { formatDate } from '../../../utils/DateUtil'

type Props = {
  data: IXmlTariffModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void // Düzeltme: parametre tipi eklendi
  onEdit?: (xmlTariff: IXmlTariffModel) => void // Düzeltme: Edit fonksiyonu eklendi
  onDelete?: (xmlTariff: IXmlTariffModel) => void // Düzeltme: Delete fonksiyonu eklendi
  sortBy?: string // Düzeltme: Sort state'leri eklendi
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const XmlTariffTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false
}) => {


  const xmlTariffColumns: TableColumn<IXmlTariffModel>[] = [
    { key: 'rateName', label: 'Tarifeler', className: 'fw-semibold' ,sortable: true},
    { key: 'startDate', label: 'Başlangıç Tarihi', render: (v) => formatDate(v) },
    { key: 'endDate', label: 'Bitiş Tarihi', render: (v) => formatDate(v) },
    { key: 'actionDate', label: 'Oluşturma Tarihi', render: (v) => formatDate(v) },
    { key: 'approvalStatus', label: 'Onay Durumu', render: (v) => getSelectLabel(APPROVAL_STATUS_OPTIONS, v) },
  ]

  // Düzeltme: TableAction'da IBranchModel tipini kullan
  const xmlTariffActions: TableAction<IXmlTariffModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (xmlTariff) => onEdit?.(xmlTariff), // Düzeltme: Parent'tan gelen fonksiyon
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (xmlTariff) => onDelete?.(xmlTariff), // Düzeltme: Parent'tan gelen fonksiyon
    },
  ]

  return (
    <DataTable
      data={data}
      columns={xmlTariffColumns}
      actions={xmlTariffActions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz Xml Tarifesi bulunamadı'
    />
  )
}